import React from 'react';
import { Spinner } from 'V2/Shared/Spinner';
import { ErrorRetry } from 'V2/Shared/ErrorRetry';
import { CheckoutAdyen, AdyenDropinHandle } from './CheckoutAdyen';
import styles from '../styles.module.css';

interface PaymentFormCardProps {
  isLoading: boolean;
  error: string | null;
  isReady: boolean;
  onRetry: () => void;
  onAdyenReady: (dropin: AdyenDropinHandle) => void;
  onFormValidChange: (isValid: boolean) => void;
  onSubmit: (paymentToken: string) => void;
}

export const PaymentFormCard: React.FC<PaymentFormCardProps> = ({
  isLoading,
  error,
  isReady,
  onRetry,
  onAdyenReady,
  onFormValidChange,
  onSubmit,
}) => {
  return (
    <div className={styles.paymentFormCard}>
      {isLoading && (
        <div className={styles.sectionLoader}>
          <Spinner variant="blue" />
        </div>
      )}
      {error && <ErrorRetry onRetry={onRetry}>{error}</ErrorRetry>}
      {isReady && (
        <CheckoutAdyen
          holderName=""
          onReady={onAdyenReady}
          onFormValidChange={onFormValidChange}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};
